import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { norm } from "@/lib/normalize";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-emerald-base">
        <div className="text-emerald-muted font-heading text-2xl">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.map(norm).includes(norm(user.roleName))) return <Navigate to="/dashboard" replace />;
  return children;
}
